import React from "react";

export default function Loading() {
  return (
    <div className="h-screen w-screen text-center align-middle">
      loading!
    </div>
  )
}
